export const SECTION_IDS = ["about", "gallery", "philosophy", "exhibitions", "testimonials", "blog", "services", "contact"];

export const LANG = {
  ru: {
    nav: ["О себе", "Галерея", "Философия", "Выставки", "Отзывы", "Блог", "Услуги", "Контакты"],
    nav2: { artworks: "Картины", constellation: "Карта", lab: "Лаборатория", prints: "Принты", workshops: "Мастер-классы", custom: "Индивидуально", collabs: "Коллаборации", about: "О себе", blog: "Блог", contact: "Контакты" },
    hero: {
      sub: "ИНТУИТИВНАЯ ЖИВОПИСЬ · КАРТИНЫ ИЗ БУДУЩЕГО",
      lead: "Авторская интуитивная живопись, живые картины для интерьера и творческие мастер-классы в Москве.",
      cta:   "Подобрать картину",
      cta2:  "Записаться на мастер-класс",
      cta3:  "Обсудить индивидуальную работу",
    },
    marquee: "ЕЛИЗАВЕТА ФЕДЬКИНА — ИНТУИТИВНАЯ ЖИВОПИСЬ — КАРТИНЫ ИЗ БУДУЩЕГО — АКРИЛ — СМЕШАННАЯ ТЕХНИКА — ГРАФИКА — МОСКВА — @DIKO.RATIVNO — ",
    funnels: {
      tag: "НАПРАВЛЕНИЯ",
      title: "Четыре",
      accent: "направления",
      sub: "Лиза создаёт не просто картины, а визуальные миры — для пространства, события, подарка и личной истории.",
      items: [
        { key: "artworks",  to: "/artworks",       t: "Картины",              d: "Оригиналы и принты с авторским характером и сильной визуальной подачей." },
        { key: "workshops", to: "/workshops",      t: "Мастер-классы",        d: "Творческий опыт для тех, кто хочет почувствовать процесс без страха «я не умею»." },
        { key: "custom",    to: "/custom",         t: "Индивидуальные работы",d: "Картины под историю, интерьер, подарок или личный запрос." },
        { key: "collabs",   to: "/collaborations", t: "Коллаборации",         d: "Выставки, арт-события, размещение работ и партнёрские проекты." },
      ],
    },
    featured: { tag: "ИЗБРАННОЕ", title: "Избранные", accent: "работы", viewAll: "Все работы →" },
    faq: {
      tag: "ЧАСТЫЕ ВОПРОСЫ", title: "Ответы", accent: "на главное",
      items: [
        { q: "Как купить картину?", a: "Оставьте заявку через форму или Telegram-бот — Лиза подтвердит наличие, согласует оплату и отправку. Возможна бронь до 7 дней." },
        { q: "Есть ли доставка?", a: "Да. По Москве — курьер, по России — СДЭК/Boxberry, международно — по запросу. Упаковка жёсткая, страховка включена." },
        { q: "Нужен ли опыт рисования для мастер-класса?", a: "Нет. Формат «интуитивной живописи» рассчитан на тех, кто никогда не рисовал. Лиза ведёт так, чтобы снять страх чистого листа." },
        { q: "Как заказать индивидуальную работу?", a: "Заполните бриф на странице «Индивидуально». Обсудим смысл, размер, сроки и бюджет, затем Лиза пришлёт эскиз на согласование." },
        { q: "Можно ли предложить площадку для выставки?", a: "Да. На «Коллаборациях» есть форма для площадок, шоурумов и брендов — Лиза лично рассматривает запросы." },
      ],
    },
    finalCta: {
      title: "Выберите следующий шаг",
      items: [
        { t: "Подобрать картину",          to: "/artworks" },
        { t: "Записаться на мастер-класс", to: "/workshops" },
        { t: "Обсудить индивидуальную",    to: "/custom" },
        { t: "Предложить коллаборацию",    to: "/collaborations" },
      ],
    },
    about: {
      tag: "01 / БИОГРАФИЯ", title: "Искусство", accent: "Интуиции",
      p1: "Елизавета Федькина — художница, работающая в направлении интуитивной живописи. Образование: колледж МГУДТ им. Косыгина (промышленный дизайн), Art & Image (стилист), РГУ им. Косыгина (искусствоведение, 2018–2022). Тема диплома — «Реализация принципов интуитивного творчества в произведениях искусства и предметной среде».",
      p2: "Свобода и счастье для меня, как художника — бесконечно воспевать цвет, пробуждать энергию в смотрящих! Всё моё творчество — ода эмоциям, чувствам и исцелению Души. Мне трудно отделить процесс моей жизни от творчества — я рисую всегда и везде.",
      p3: "Живые орнаментальные, интерьерные картины, написанные в потоковом состоянии. Каждая картина рождается из эмоции, запроса, слова, имени, точки, цвета и формы. Работы экспонировались в ODA Decor, G1.gallery, Meeting Point, IZZI Decor и арт-баре Beer & Art. г. Москва.",
    },
    gallery: { tag: "02 / ПОРТФОЛИО", title: "Избранные", accent: "Работы", scroll: "← Прокрутите →", all: "Все", close: "Закрыть" },
    philosophy: {
      tag: "03 / ФИЛОСОФИЯ", title: "Метод", accent: "Создания",
      steps: [
        { n: "01", t: "Погружение", d: "Медитативная настройка — полное присутствие в моменте. Иногда работа идёт с закрытыми глазами, когда рука следует за внутренним чувством" },
        { n: "02", t: "Импульс",    d: "Каждая картина рождается из эмоции, запроса, слова, имени, точки, цвета и формы. Первый мазок задаёт энергию всего полотна" },
        { n: "03", t: "Поток",      d: "Живые орнаментальные формы проявляются в потоковом состоянии. Техника сродни импрессионистической живописи — новое направление в визуальном искусстве" },
        { n: "04", t: "Портал",     d: "Картина становится порталом — в работах отражаются приходящие образы, с которыми каждый увидевший может себя ассоциировать" },
      ],
      quote: "Мои картины — это порталы в другие измерения. Мне трудно отделить процесс моей жизни от творчества. Я живу настолько через визуальное восприятие, что обыденные вещи для меня являются источником вдохновения.",
    },
    exhibitions: { tag: "04 / ВЫСТАВКИ", title: "Выставочная", accent: "Деятельность" },
    testimonials: {
      tag: "05 / ОТЗЫВЫ", title: "Что говорят", accent: "Клиенты",
      items: [
        { text: "Елизавета создала для нас картину, которая полностью изменила энергетику пространства. Каждый гость спрашивает о ней — она как будто живая.", author: "Мария К.", role: "Заказ для гостиной" },
        { text: "Мастер-класс по интуитивной живописи стал для меня настоящим открытием. Я никогда не рисовала, но под руководством Лизы создала свою первую картину.", author: "Анна Д.", role: "Участница мастер-класса" },
        { text: "Заказывали серию из трёх работ для ресторана. Лиза прочувствовала концепцию с первой встречи. Результат превзошёл ожидания — гости фотографируют картины не реже, чем еду.", author: "Алексей В.", role: "Оформление ресторана" },
        { text: "Интуитивный портрет, который написала Елизавета — это зеркало души. Я была поражена, насколько абстрактная живопись может точно передать внутреннее состояние.", author: "Ольга С.", role: "Интуитивный портрет" },
      ],
    },
    services: {
      tag: "06 / УСЛУГИ", title: "Чем могу", accent: "Помочь",
      items: [
        { i: "01", t: "Картина на заказ",       d: "Интуитивная картина по вашему запросу — передам энергию и настроение через цвет и форму", p: "от ₽15 000" },
        { i: "02", t: "Мастер-класс",           d: "Групповые и индивидуальные занятия по интуитивной живописи для начинающих и продвинутых", p: "от ₽3 000" },
        { i: "03", t: "Интуитивный портрет",    d: "Абстрактный энергетический портрет — картина, отражающая вашу внутреннюю сущность", p: "от ₽20 000" },
        { i: "04", t: "Оформление пространств", d: "Подбор и создание серии картин для интерьеров — квартиры, офисы, рестораны", p: "по запросу" },
      ],
    },
    contact: {
      tag: "07 / КОНТАКТЫ", title: "Давайте", accent: "Создадим",
      sub: "Заполните форму или свяжитесь напрямую — отвечу в течение 24 часов",
      f: { name: "Имя", email: "Email", phone: "Телефон", type: "Тип запроса", msg: "Подробности", send: "Отправить заявку", ok: "✓ Заявка отправлена!" },
      types: ["Картина на заказ", "Интуитивный портрет", "Мастер-класс", "Оформление пространства", "Покупка готовой работы", "Другое"],
    },
    footer: "Все права защищены",
    stats: [{ n: 30, s: "+", l: "Картин" }, { n: 6, s: "+", l: "Выставок" }, { n: 5, s: "", l: "Галерей" }, { n: 2, s: "", l: "Диплома" }],

    workshopsPage: {
      tag: "МАСТЕР-КЛАССЫ", title: "Интуитивная", accent: "живопись",
      lead: "Группы, пары и индивидуальные занятия. Опыт рисования не нужен — метод рассчитан на то, чтобы снять страх чистого листа.",
      formats: [
        { t: "Групповой",      d: "4–10 участников, 3 часа, готовая картина на холсте 40×50 см уходит с вами.", p: "от 3 000 ₽" },
        { t: "Парный",         d: "Для двоих. Атмосферный формат для пары, подруг или близких.",               p: "от 7 000 ₽" },
        { t: "Индивидуальный", d: "1 на 1 с Лизой. Глубокий разбор, личный запрос, любой размер работы.",      p: "от 12 000 ₽" },
      ],
      bookCta: "Записаться",
    },
    customPage: {
      tag: "ИНДИВИДУАЛЬНО", title: "Картина", accent: "под вас",
      lead: "Авторская работа под историю, имя, интерьер или подарок. Пишу в авторской технике — ваша история превращается в визуальный портал.",
      steps: [
        { n: "01", t: "Бриф",     d: "Вы описываете повод, настроение, размер, сроки и референсы." },
        { n: "02", t: "Эскиз",    d: "Через 3–7 дней присылаю концепт-эскиз и точную смету." },
        { n: "03", t: "Работа",   d: "После согласования — 3–6 недель на создание. Показываю этапы." },
        { n: "04", t: "Доставка", d: "Упакованная работа с сертификатом подлинности. Москва — курьер, Россия — СДЭК." },
      ],
      cta: "Оставить бриф",
      briefFields: { purpose: "Для себя или в подарок?", story: "История, повод, запрос", size: "Примерный размер (см)", deadline: "Дедлайн", budget: "Бюджет", refs: "Референсы / ссылки" },
    },
    collaborationsPage: {
      tag: "КОЛЛАБОРАЦИИ", title: "Арт-события", accent: "и партнёрства",
      lead: "Работаю с площадками, шоурумами, ресторанами, брендами и дизайнерами. Выставка, постоянное размещение, коллаборационный продукт или арт-событие.",
      formats: [
        { t: "Выставка",     d: "Персональная или групповая, с открытием и пресс-днём." },
        { t: "Размещение",   d: "Постоянная или временная экспозиция в шоуруме, ресторане, отеле." },
        { t: "Арт-событие",  d: "Мастер-класс под ключ, живопись на мероприятии, корпоративный досуг." },
        { t: "Коллаборация", d: "Принты, лимитированная серия, капсульный продукт, коллаб с брендом." },
      ],
      cta: "Предложить проект",
    },
    artworkDetail: {
      back: "← Ко всем работам",
      meta: { collection: "Серия", material: "Материал", size: "Размер", year: "Год", status: "Статус" },
      storyTitle: "История работы",
      bestForTitle: "Куда подходит",
      statusMap: { in_stock: "В наличии", reserved: "Забронирована", sold: "Продана", archived: "В архиве" },
      ctaPrimary: "Забронировать",
      ctaSecondary: "Запросить детали",
      noteSold: "Работа продана. Возможен принт или похожая работа под заказ — напишите.",
      askedFor: "Интерес к работе",
    },
  },

  en: {
    nav: ["About", "Gallery", "Philosophy", "Exhibitions", "Reviews", "Blog", "Services", "Contact"],
    nav2: { artworks: "Artworks", constellation: "Map", lab: "Lab", prints: "Prints", workshops: "Workshops", custom: "Custom", collabs: "Collaborations", about: "About", blog: "Blog", contact: "Contact" },
    hero: {
      sub: "INTUITIVE PAINTING · PICTURES FROM THE FUTURE",
      lead: "Authentic intuitive painting, living artworks for interiors, and creative workshops in Moscow.",
      cta:   "Find a painting",
      cta2:  "Book a workshop",
      cta3:  "Commission a custom piece",
    },
    marquee: "ELIZAVETA FEDKINA — INTUITIVE PAINTING — PICTURES FROM THE FUTURE — ACRYLIC — MIXED MEDIA — GRAPHICS — MOSCOW — @DIKO.RATIVNO — ",
    funnels: {
      tag: "DIRECTIONS",
      title: "Four",
      accent: "directions",
      sub: "Liza creates not just paintings but visual worlds — for space, occasion, gift and personal story.",
      items: [
        { key: "artworks",  to: "/artworks",       t: "Artworks",    d: "Originals and prints with strong authorial voice and visual punch." },
        { key: "workshops", to: "/workshops",      t: "Workshops",   d: "Creative experience for those who want to feel the process without the «I can't draw» fear." },
        { key: "custom",    to: "/custom",         t: "Custom work", d: "Paintings for a story, interior, gift or personal request." },
        { key: "collabs",   to: "/collaborations", t: "Collabs",     d: "Exhibitions, art events, long-term placement and partner projects." },
      ],
    },
    featured: { tag: "FEATURED", title: "Selected", accent: "works", viewAll: "All works →" },
    faq: {
      tag: "FAQ", title: "Answers", accent: "to the main",
      items: [
        { q: "How do I buy a painting?", a: "Submit a request via form or Telegram bot — Liza confirms availability, handles payment and shipping. Up to 7-day hold available." },
        { q: "Do you ship?", a: "Yes. Within Moscow — courier; across Russia — SDEK/Boxberry; international — on request. Rigid packaging, insurance included." },
        { q: "Do I need drawing experience for a workshop?", a: "No. «Intuitive painting» is designed for beginners. Liza holds the space so the blank canvas no longer scares you." },
        { q: "How do I commission a custom piece?", a: "Fill out the brief on the Custom page. We discuss meaning, size, timeline and budget, then Liza sends a concept sketch for approval." },
        { q: "Can I propose a venue for an exhibition?", a: "Yes. The Collaborations page has a form for venues, showrooms and brands — Liza reviews requests personally." },
      ],
    },
    finalCta: {
      title: "Choose your next step",
      items: [
        { t: "Find a painting",      to: "/artworks" },
        { t: "Book a workshop",      to: "/workshops" },
        { t: "Commission custom",    to: "/custom" },
        { t: "Propose a collab",     to: "/collaborations" },
      ],
    },
    about: {
      tag: "01 / BIOGRAPHY", title: "The Art of", accent: "Intuition",
      p1: "Elizaveta Fedkina is an artist working in intuitive painting. Education: Kosygin MGUTD College (industrial design), Art & Image (stylist), Kosygin RSU (art history, 2018–2022). Thesis: 'Implementation of intuitive creativity principles in works of art and the material environment.'",
      p2: "Freedom and happiness for me as an artist is to endlessly celebrate color, to awaken energy in those who look! All my work is an ode to emotions, feelings, and the healing of the Soul. I find it hard to separate my life from creativity — I draw always and everywhere.",
      p3: "Living ornamental, interior paintings created in a flow state. Each painting is born from emotion, request, word, name, dot, color and form. Works exhibited at ODA Decor, G1.gallery, Meeting Point, IZZI Decor, and Beer & Art bar. Moscow, Russia.",
    },
    gallery: { tag: "02 / PORTFOLIO", title: "Selected", accent: "Works", scroll: "← Scroll →", all: "All", close: "Close" },
    philosophy: {
      tag: "03 / PHILOSOPHY", title: "Creative", accent: "Method",
      steps: [
        { n: "01", t: "Immersion", d: "Meditative attunement — complete presence in the moment. Sometimes working with eyes closed, when the hand follows inner feeling" },
        { n: "02", t: "Impulse",   d: "Each painting is born from emotion, request, word, name, dot, color and form. The first stroke sets the energy of the entire canvas" },
        { n: "03", t: "Flow",      d: "Living ornamental forms emerge in a flow state. The technique is akin to impressionist painting — a new direction in visual art" },
        { n: "04", t: "Portal",    d: "The painting becomes a portal — arriving images are reflected in the works, with which each viewer can identify themselves" },
      ],
      quote: "My paintings are portals to other dimensions. I find it hard to separate my life from creativity. I live so deeply through visual perception that everyday things become my source of inspiration.",
    },
    exhibitions: { tag: "04 / EXHIBITIONS", title: "Exhibition", accent: "Activity" },
    testimonials: {
      tag: "05 / REVIEWS", title: "What Clients", accent: "Say",
      items: [
        { text: "Elizaveta created a painting for us that completely changed the energy of the space. Every guest asks about it — it feels alive.", author: "Maria K.", role: "Living room commission" },
        { text: "The intuitive painting workshop was a real discovery for me. I had never painted before, but under Liza's guidance I created my first painting.", author: "Anna D.", role: "Workshop participant" },
        { text: "We ordered a series of three works for a restaurant. Liza felt the concept from the first meeting. The result exceeded expectations.", author: "Alexey V.", role: "Restaurant design" },
        { text: "The intuitive portrait that Elizaveta painted is a mirror of the soul. I was amazed how abstract painting can accurately convey an inner state.", author: "Olga S.", role: "Intuitive portrait" },
      ],
    },
    services: {
      tag: "06 / SERVICES", title: "How I Can", accent: "Help",
      items: [
        { i: "01", t: "Custom Painting",    d: "Intuitive painting by your request — conveying energy and mood through color and form", p: "from ₽15,000" },
        { i: "02", t: "Workshop",           d: "Group and individual intuitive painting classes for beginners and advanced students", p: "from ₽3,000" },
        { i: "03", t: "Intuitive Portrait", d: "Abstract energy portrait — a painting reflecting your inner essence", p: "from ₽20,000" },
        { i: "04", t: "Space Design",       d: "Selection and creation of painting series for interiors — apartments, offices, restaurants", p: "on request" },
      ],
    },
    contact: {
      tag: "07 / CONTACT", title: "Let's", accent: "Create",
      sub: "Fill out the form or reach out directly — I'll respond within 24 hours",
      f: { name: "Name", email: "Email", phone: "Phone", type: "Request Type", msg: "Details", send: "Submit Request", ok: "✓ Request submitted!" },
      types: ["Custom Painting", "Intuitive Portrait", "Workshop", "Space Design", "Purchase a Finished Work", "Other"],
    },
    footer: "All rights reserved",
    stats: [{ n: 30, s: "+", l: "Paintings" }, { n: 6, s: "+", l: "Exhibitions" }, { n: 5, s: "", l: "Galleries" }, { n: 2, s: "", l: "Diplomas" }],

    workshopsPage: {
      tag: "WORKSHOPS", title: "Intuitive", accent: "painting",
      lead: "Groups, pairs, and one-on-ones. No drawing experience needed — the method is built to dissolve the blank-canvas fear.",
      formats: [
        { t: "Group",      d: "4–10 participants, 3 hours, finished 40×50 cm canvas goes home with you.", p: "from ₽3,000" },
        { t: "Pair",       d: "Atmospheric format for couples, close friends or family.",                  p: "from ₽7,000" },
        { t: "One-on-one", d: "Private session with Liza. Deep unpacking, personal request, any size.",    p: "from ₽12,000" },
      ],
      bookCta: "Book",
    },
    customPage: {
      tag: "CUSTOM", title: "A painting", accent: "made for you",
      lead: "Custom work for a story, name, interior or gift. Your story becomes a visual portal in Liza's signature technique.",
      steps: [
        { n: "01", t: "Brief",    d: "You describe occasion, mood, size, timeline, references." },
        { n: "02", t: "Sketch",   d: "In 3–7 days I send a concept sketch and a firm quote." },
        { n: "03", t: "Work",     d: "After approval — 3–6 weeks. I share progress." },
        { n: "04", t: "Delivery", d: "Packed artwork with a certificate of authenticity. Moscow — courier, Russia — SDEK." },
      ],
      cta: "Send brief",
      briefFields: { purpose: "For you or a gift?", story: "Story, occasion, request", size: "Approx. size (cm)", deadline: "Deadline", budget: "Budget", refs: "References / links" },
    },
    collaborationsPage: {
      tag: "COLLABORATIONS", title: "Art events", accent: "and partnerships",
      lead: "Working with venues, showrooms, restaurants, brands and designers. Exhibitions, long-term placement, collab products, art events.",
      formats: [
        { t: "Exhibition", d: "Solo or group, with opening and press day." },
        { t: "Placement",  d: "Permanent or seasonal display in a showroom, restaurant, hotel." },
        { t: "Art event",  d: "Turnkey workshop, live painting at an event, corporate experience." },
        { t: "Collab",     d: "Prints, limited edition, capsule product, brand co-creation." },
      ],
      cta: "Propose a project",
    },
    artworkDetail: {
      back: "← Back to all works",
      meta: { collection: "Collection", material: "Material", size: "Size", year: "Year", status: "Status" },
      storyTitle: "Story",
      bestForTitle: "Best for",
      statusMap: { in_stock: "In stock", reserved: "Reserved", sold: "Sold", archived: "Archived" },
      ctaPrimary: "Reserve",
      ctaSecondary: "Ask details",
      noteSold: "This work is sold. A print or a similar custom piece is possible — write to us.",
      askedFor: "Interest in work",
    },
  },
};
